import React from 'react';
import ToggleChipGrid from '../DesignSystem/ToggleChipGrid';

// Wizard input for FieldworkPeriodApplyTable (PI Mass Status Update). `value` is
// the wizard's [{apply, startDate, endDate}] array; only `apply` is edited here —
// dates pass through untouched. No section label: the wizard field row already
// renders the "Fieldwork Periods" label.
function FieldworkPeriodGrid({ value, onChange }) {
  const periods = value ?? [];

  const items = periods.map((period, index) => ({
    key: index,
    label: `Period ${index + 1}`,
    checked: period.apply,
  }));

  const handleChange = (updatedItems) =>
    onChange(periods.map((period, index) => ({ ...period, apply: updatedItems[index].checked })));

  return (
    <ToggleChipGrid
      items={items}
      onChange={handleChange}
    />
  );
}

export default FieldworkPeriodGrid;
